import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0290d360"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "web-menu-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_el_menu = _resolveComponent("el-menu");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_menu, {
    ref: "menu",
    class: "el-menu-vertical-demo",
    onClose: _ctx.handleClose,
    onSelect: _ctx.select,
    "default-openeds": _ctx.opends,
    "default-active": _ctx.defaultActive
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuList, (group, index) => {
      return _openBlock(), _createBlock(_component_el_sub_menu, {
        key: index,
        index: index + ''
      }, {
        title: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(group.name), 1)]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.list, (item, idx) => {
          return _openBlock(), _createBlock(_component_el_menu_item, {
            key: idx,
            index: item.id,
            id: item.id
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
            _: 2
          }, 1032, ["index", "id"]);
        }), 128))]),
        _: 2
      }, 1032, ["index"]);
    }), 128))]),
    _: 1
  }, 8, ["onClose", "onSelect", "default-openeds", "default-active"])]);
}